<div class="photo-card" [class.selected]="isSelected" [class.main-photo]="photo.isMain">
  <div class="photo-container" (click)="onSelect()">
    <img [src]="photo.url" [alt]="photo.name || photo.photo_id" />
    <div class="overlay" *ngIf="showSelection">
      <div class="selection-indicator">
        <i class="fas" [class.fa-check-circle]="isSelected" [class.fa-circle]="!isSelected"></i>
      </div>
    </div>
    <div class="main-photo-indicator" matTooltip="Main Photo" i18n-matTooltip *ngIf="photo.isMain">
      <i class="fas fa-star"></i>
    </div>
    <div class="actions-container" (click)="$event.stopPropagation()">
      <button
        mat-icon-button
        class="hover-action"
        *ngIf="showDelete"
        (click)="onDelete()"
        color="warn"
        matTooltip="Delete Photo"
      >
        <i class="cs-icon cs-icon-trash"></i>
      </button>
      <button
        mat-icon-button
        class="hover-action"
        *ngIf="showSetMain && !photo.isMain"
        (click)="onSetMain()"
        matTooltip="Set as Main Photo"
      >
        <i class="fas fa-star"></i>
      </button>
      <button mat-icon-button *ngIf="photo.message" [matTooltip]="photo.message">
        <i class="fas fa-info-circle"></i>
      </button>
    </div>
    <div class="photo-metadata">
      <small class="photo-name">{{ photo.name || photo.photo_id }}</small>
      <div class="d-flex gap-2 align-items-center flex-wrap">
        <small
          class="badge"
          *ngIf="photo.quality"
          [ngClass]="{
            'bg-success': photo.quality === 'high',
            'bg-warning text-dark': photo.quality === 'medium',
            'bg-danger': photo.quality === 'low'
          }"
        >
          <span i18n>Quality:</span> {{ photo.quality | titleCase }}
        </small>
        <small class="badge bg-secondary" *ngIf="photo.width && photo.height">
          {{ photo.width }} x {{ photo.height }}
        </small>
        <small class="badge bg-default2 text-dark" *ngIf="photo.status">
          <span i18n>Status:</span> {{ photo.status | titleCase }}
        </small>
      </div>
    </div>
  </div>
  <div class="tags-section m-2" *ngIf="showTags">
    <app-form-tags2
      [value]="photo.tag_ids || []"
      [items]="availableTags"
      [bindLabel]="'tag'"
      [bindValue]="'id'"
      [placeholder]="'Add tags'"
      [searchable]="true"
      [addNewTag]="false"
      [showLabel]="false"
      [inline]="true"
      (valueChange)="onTagsChange($event)"
      class="w-100"
    ></app-form-tags2>
  </div>
</div>
